/**
 * Normalize Ask Evans assistant markdown for PDF + UI (lists, numbering, nesting).
 */

/** Renumber repeated `1.` lines within each numbered-list run. */
export const renumberOrderedListsInMarkdown = (markdown) => {
  const lines = String(markdown || '').replace(/\r\n/g, '\n').split('\n');
  const out = [];
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    const olMatch = line.match(/^(\s*)\d+\.\s+(.*)$/);
    if (!olMatch) {
      out.push(line);
      i += 1;
      continue;
    }
    let n = 0;
    while (i < lines.length) {
      const l = lines[i];
      const numbered = l.match(/^(\s*)\d+\.\s+(.*)$/);
      if (numbered) {
        n += 1;
        out.push(`${numbered[1]}${n}. ${numbered[2]}`);
        i += 1;
        continue;
      }
      if (!l.trim()) {
        out.push(l);
        i += 1;
        continue;
      }
      if (/^\s*[-*+]\s/.test(l) || /^\s{2,}\S/.test(l)) {
        out.push(l);
        i += 1;
        continue;
      }
      break;
    }
  }
  return out.join('\n');
};

/** Indent `-` bullets that belong to the preceding numbered item (GFM nested list). */
export const indentNestedBulletsInMarkdown = (markdown) => {
  const lines = String(markdown || '').replace(/\r\n/g, '\n').split('\n');
  const out = [];
  let afterNumbered = false;
  lines.forEach((line) => {
    const trimmed = line.trim();
    if (/^\d+\.\s+/.test(trimmed)) {
      afterNumbered = true;
      out.push(line);
      return;
    }
    if (afterNumbered && /^[-*+]\s+/.test(trimmed)) {
      out.push(`   ${trimmed}`);
      return;
    }
    if (trimmed && !/^[-*+]\s+/.test(trimmed) && !/^\d+\.\s+/.test(trimmed)) {
      afterNumbered = false;
    }
    out.push(line);
  });
  return out.join('\n');
};

/** Full pass for assistant answers in chat UI and session PDF. */
export const formatAskEvansAnswerMarkdown = (markdown) => {
  let text = String(markdown || '').replace(/\r\n/g, '\n').trim();
  if (!text) return '';
  text = indentNestedBulletsInMarkdown(text);
  text = renumberOrderedListsInMarkdown(text);
  return text;
};
